import { render } from "./FooterPart.vue?vue&type=template&id=22b48e80&scoped=true"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import "./FooterPart.vue?vue&type=style&index=0&id=22b48e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b48e80"]])

export default __exports__